import { Alert } from "react-native";

const sendEmployeeEmail = async (
  email,
  name,
  employeeId,
  department,
  password,
  companyName,
  companyCode,
  isForgot = false
) => {
  let subject, body;

  if (isForgot) {
    subject = `Password Recovery - ${companyName}`;
    body = `Dear ${name},\n\nAs requested, here is your account password for ${companyName}:- ${companyCode}:\n\nEmployee ID: ${employeeId}\nPassword: ${password}\n\nPlease keep this information secure.\n\nBest regards,\nSowin Enterprise`;
  } else {
    subject = `Welcome to ${companyName}`;
    body = `Dear ${name},\n\nWelcome to our platform! We are excited to have you onboard.\n\nHere are your account details:\n- Company: ${companyName}\n- Company Code : ${companyCode}\n- Employee Name: ${name}\n- Employee ID: ${employeeId}\n- Email: ${email}\n- Department: ${department}\n- Password: ${password}\n\nPlease keep this information secure. If you have any questions, feel free to contact us.\n\nBest regards,\nSowin Enterprises`;
  }

  const emailData = {
    personalizations: [
      {
        to: [{ email }],
        subject,
      },
    ],
    from: { email: "tanmaygharat957@gmail.com" }, // Your verified sender email
    content: [
      {
        type: "text/plain",
        value: body,
      },
    ],
  };

  try {
    const response = await fetch("https://api.sendgrid.com/v3/mail/send", {
      method: "POST",
      headers: {
        Authorization: `Bearer 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`, // Your API key
        "Content-Type": "application/json",
      },
      body: JSON.stringify(emailData),
    });

    if (!response.ok) {
      const error = await response.json();
      console.error("Error sending email:", error);
      Alert.alert("Error", "Failed to send email.");
    } else {
      console.log("Email sent successfully!");
    }
  } catch (err) {
    console.error("Error:", err.message);
    Alert.alert("Error", "Failed to send email.");
  }
};

export default sendEmployeeEmail;
